<script>
import { AppTracker } from '@/components/ui/tracker'

const BaseOverview = () => import('../components/BaseOverview')

export default {
  functional: true,

  props: {
    totalWeight: {
      type: Number,
      default: 0
    },

    ticketAmount: {
      type: Number,
      default: 0
    },

    loading: {
      type: Boolean,
      default: false
    }
  },

  render(h, { data, props }) {
    return (
      <BaseOverview {...data} loading={props.loading}>
        <AppTracker
          label="น้ำหนักรวม"
          value={props.totalWeight}
          unit="กรัม"
          format="0,0.00"
        />
        <AppTracker
          label="จำนวนตั๋วขายฝาก"
          value={props.ticketAmount}
          unit="รายการ"
        />
      </BaseOverview>
    )
  }
}
</script>
